import { useEffect, useState } from "react";
import FieldBage from "@components/global/new/FieldBage/FieldBage";
import { IEfficiencyProps } from "./Efficiency.props";
import cn from "classnames";
import { useIntl } from "react-intl";
import { ALGOS_E } from "@constants/Algos";
import { useFirstRender } from "@utils/hooks/useFirstRender";
import { getDevivedHash } from "@utils/hash.utils";

import styles from "./Efficiency.module.scss";

export default function Efficiency(props: IEfficiencyProps) {
  const { isError, cons, perf, algo, commonEff, effectiveBage, className } =
    props;
  const isFirstRender = useFirstRender();
  const { formatMessage } = useIntl();

  const [eff, setEff] = useState<number>(commonEff);

  useEffect(() => {
    setEff(commonEff);
  }, [commonEff]);

  //рассчет эффективности
  useEffect(() => {
    if (isFirstRender) return;

    if (!cons) return;

    const [calculatedPerfomance] = getDevivedHash(perf, {
      unit: algo as ALGOS_E,
    }).split(" ");
    const calc = +(Math.floor(Number(calculatedPerfomance)) / cons).toFixed(2);

    setEff(calc);
  }, [perf, effectiveBage, cons]);

  //reset
  useEffect(() => {
    if (!props.reset) return;
    setEff(commonEff || 0);
  }, [props.reset]);

  return (
    <FieldBage
      className={cn(styles.wrapper, className)}
      name={formatMessage({ id: "calc.efficiency" })}
      bage={effectiveBage}
      id='efficiency'
      defaultValue={eff}
      oldValue={eff}
      isError={isError}
      hasPrevValue={false}
      up
      disabled
      bageClassName={styles.bage_width}
    />
  );
}
